var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMission(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0001 64.2797C56.5436 64.2797 64.2802 56.5432 64.2802 46.9997C64.2802 37.4562 56.5436 29.7197 47.0001 29.7197C37.4566 29.7197 29.7202 37.4562 29.7202 46.9997C29.7202 56.5432 37.4566 64.2797 47.0001 64.2797Z",
    fill: "#14C7C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 90C23.28 90 4 70.72 4 47C4 23.28 23.28 4 47 4C70.72 4 90 23.28 90 47C90 70.72 70.72 90 47 90ZM47 10C26.6 10 10 26.6 10 47C10 67.4 26.6 84 47 84C67.4 84 84 67.4 84 47C84 26.6 67.4 10 47 10Z",
    fill: "#03182F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9999 77.04C30.4399 77.04 16.96 63.56 16.96 47C16.96 30.44 30.4399 16.96 46.9999 16.96C63.5599 16.96 77.0399 30.44 77.0399 47C77.0399 63.56 63.5599 77.04 46.9999 77.04ZM46.9999 23C33.7599 23 22.96 33.76 22.96 47.04C22.96 60.32 33.7199 71.08 46.9999 71.08C60.2799 71.08 71.0399 60.32 71.0399 47.04C71.0399 33.76 60.2799 23 46.9999 23Z",
    fill: "#03182F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.79738fbc38c0c004cef23c9403115fef.svg";
export { ForwardRef as ReactComponent };